import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CareGuideSectionForm from '../containers/CareGuideSectionFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuideSectionEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuideSectionEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('care_guide_section_route_edit')} />
          <CareGuideSectionForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideSectionEditScreen;

Logger.log('silly', `CareGuideSectionEditScreen loaded.`);
